"use client";
import React from "react";
import { TurnrTooltip } from "rylak-common/src/components/TurnrTooltip/TurnrTooltip";
import TurnrMinusIconButton from "~/components/buttons/icon-buttons/TurnrMinusIconButton.jsx";

export default function QualityCheckRemoveItemButton({ onClick, removeTooltipContent }) {
    const disabled = !onClick;
    return (
        <TurnrTooltip content={removeTooltipContent}>
            <div
                style={{
                    marginLeft: "auto",
                    visibility: "visible",
                }}
            >
                <TurnrMinusIconButton disabled={disabled} onClick={onClick} />
            </div>
        </TurnrTooltip>
    );
}
